import { render, staticRenderFns } from "./GlobalDashboard.vue?vue&type=template&id=3edd6d7d&scoped=true"
import script from "./GlobalDashboard.vue?vue&type=script&lang=js"
export * from "./GlobalDashboard.vue?vue&type=script&lang=js"
import style0 from "./GlobalDashboard.vue?vue&type=style&index=0&id=3edd6d7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd6d7d",
  null
  
)

export default component.exports